import { apiClient } from "./client"

import type { Subject } from "@/types"

// PRD-37 / ADR-0031 — school-scoped subject catalog. No pagination (bounded
// inventory per pagination.md's exemption) and no params: the backend scopes
// to the professor's own school and returns only ACTIVE subjects server-side.
export const subjectsApi = {
  list: () => apiClient.get<Subject[]>("/subjects/").then((r) => r.data),
}
